module.exports = __webpack_public_path__ + "static/media/perfect-design.d2500863.jpg";